import { type HistoryGroup } from "@/features/history/utils";
import { type History } from "@repo/api";
import { Text } from "@repo/skapa";
import { t } from "@repo/translation";
import {
  translateKey,
  translatePrecallReason,
  translatePrecallResult,
} from "@repo/ui";
import { isDefined } from "@repo/utils";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface Props {
  history: History | HistoryGroup;
}

const getPrecallUpdateDetail = (history: History) => {
  const result = history.details?.result;
  const reason = history.details?.reason;
  return [
    translatePrecallResult(result),
    reason && reason !== "OTHER"
      ? t("prompt.reason", { reason: translatePrecallReason(reason) })
      : null,
  ].filter(isDefined);
};

export const PrecallHistoryItem = ({ history }: Props) => {
  return (
    <HistoryListViewItem
      history={history}
      control="default"
      title={translateKey(history.title) ?? ""}
      description={
        <>
          {getPrecallUpdateDetail(history)?.map((el, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Text key={i} textStyle="Body.S">
              {el}
            </Text>
          ))}
          <Text textStyle="Body.S">{history.note}</Text>
        </>
      }
    />
  );
};
